







































































































































































































































import { defineComponent, PropType } from "@vue/composition-api"
import { TaskProcessQueryBodyInfo } from "../../api"

// hooks
import useGiftTaskItem from "./useGiftTaskItem"

// components
import Loading from "../Common/Loading.vue"
import PureTipsBox from "../Common/PureTipsBox.vue"
import { GiftTaskConfigItem } from "../../config"

export type HandleShowTipsBox = {
  // eslint-disable-next-line no-unused-vars
  handleShow: (v: boolean) => void
}

export default defineComponent({
  name: "GiftTaskItem",
  components: {
    Loading,
    PureTipsBox
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    },
    taskConfig: {
      type: Object as PropType<GiftTaskConfigItem>,
      required: true
    },
    totalTaskError: {
      type: Boolean,
      required: true
    },
    ccbScore: {
      type: Object as PropType<{
        weekCcbScore: number
        monthCcbScore: number
      }>,
      required: true
    },
    ccbWeekProcess: {
      type: Object as PropType<TaskProcessQueryBodyInfo | null>
    },
    ccbMonthProcess: {
      type: Object as PropType<TaskProcessQueryBodyInfo | null>
    }
  },
  setup(props, { emit }) {
    const giftTaskItem = useGiftTaskItem({ props, emit })
    return giftTaskItem
  }
})
